/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.array.push.js";
import * as repayService from '@/services/repay';
import { Toast } from 'vant';
import { useUserStore } from '@/stores/modules/user';
export default {
    __name: 'index',
    setup: function(__props) {
        var userStore = useUserStore();
        var route = useRoute();
        var router = useRouter();
        var userKey = ref(route.query.userId);
        var reqRepayToken = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var params, _ref, coinMarker, mobileNumber, titleCase, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            params = {
                                // userKey: 'k10TgOhiNNF4xjREbnOJnA',
                                cipherText: userKey.value
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                repayService.queryRepayToken(params)
                            ];
                        case 2:
                            _ref = _state.sent(), coinMarker = _ref.coinMarker, mobileNumber = _ref.mobileNumber, titleCase = _ref.titleCase;
                            console.log(coinMarker, 'token');
                            console.log(mobileNumber, 'phone');
                            console.log(titleCase, 'name');
                            userStore.update({
                                token: coinMarker,
                                phone: mobileNumber,
                                name: titleCase
                            });
                            console.log(userStore.token, 'userstore');
                            router.push('/repayment/h5/list');
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function reqRepayToken() {
                return _ref.apply(this, arguments);
            };
        }();
        reqRepayToken();
        return {
            __sfc: true,
            userStore: userStore,
            route: route,
            router: router,
            userKey: userKey,
            reqRepayToken: reqRepayToken
        };
    }
};
